import { render, staticRenderFns } from "./AlertReceiversList.vue?vue&type=template&id=0ec0fc32&scoped=true&"
import script from "./AlertReceiversList.vue?vue&type=script&lang=js&"
export * from "./AlertReceiversList.vue?vue&type=script&lang=js&"
import style0 from "./AlertReceiversList.vue?vue&type=style&index=0&id=0ec0fc32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0fc32",
  null
  
)

export default component.exports